import React, { useEffect, useMemo } from 'react';
import { Backdrop, CircularProgress, Typography, useTheme } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { publicProfileService } from 'shared/services/publicProfileService';
import AsyncShareableProfile from 'components/AsyncShareableProfile/AsyncShareableProfile';

interface Props {
  profileId?: string;
  onClose?: () => void;
  viewProfile?: boolean;
  shareableProfileErrorCallback?: (hasError: boolean) => void;
}

const PublicProfile: React.FC<Props> = ({ profileId, onClose, viewProfile, shareableProfileErrorCallback }) => {
  //useParams to get profile_id
  const { talent_slug, profile_id } = useParams<{ talent_slug: string; profile_id: string }>();
  const savedTheme = useTheme().palette.type;
  //query params to get division_id
  const query = new URLSearchParams(window.location.search);
  const division_id = query.get('division_id');
  const url = window.location.pathname;
  //get the first part of the url
  const region = url.split('/')[1];

  // Get Shareable profile data

  const publicInfo = {
    countryCode: region || '',
    talentSlug: talent_slug || '',
    companySlug: profile_id || '',
    divisionId: division_id || '',
  };

  const { getPublicProfile, getShareableProfile } = publicProfileService();

  const {
    data: profileData,
    isLoading: profileLoading,
    isError: shareableProfileError,
    isFetching,
  } = getShareableProfile(profileId);
  const { data: publicProfileData, isLoading: publicProfileLoading } = getPublicProfile(publicInfo);

  useEffect(() => {
    if (shareableProfileError && shareableProfileErrorCallback) {
      shareableProfileErrorCallback(true);
    }
  }, [shareableProfileError]);

  const profileDataFinal = useMemo(() => {
    if (profileData?.data || publicProfileData?.data) {
      if (profileId) return profileData?.data?.profile;
      else return publicProfileData?.data.public_profile;
    }
  }, [profileData, publicProfileData, profileId]);

  if (!profileId && !publicProfileLoading && !publicProfileData?.data?.public_profile) {
    return <Typography>Profile not found</Typography>;
  }

  return shareableProfileError ? null : profileLoading || Boolean(!profileDataFinal) ? (
    <Backdrop open style={{ zIndex: useTheme().zIndex.drawer + 1 }}>
      <CircularProgress />
    </Backdrop>
  ) : (
    <AsyncShareableProfile
      shareableProfileLoading={publicProfileLoading || isFetching}
      publicProfile={profileDataFinal}
      theme={savedTheme}
      noHeader={Boolean(profileId)}
      noFooter={Boolean(profileId)}
      open={viewProfile}
      onClose={onClose}
    />
  );
};

export default PublicProfile;
